export const CUSTOMER_NAMES: Record<string, string> = {
  '89.0004': 'ArgSitIhub PP',
  '81.628': 'Tolmar',
  '81.118': 'Lenovo',
  '82.557': 'Halla / MEGVII',
  '89.0024': 'FIP WS PP',
  '80.951': 'Sanofi',
  '89.0005': 'FIPIHUB PP',
  '89.0015': 'FOL IPX PP',
  '89.0023': 'FIP BB PP',
  '89.0022': 'FIP KL PP',
  '82.844': 'FIP HAK PP / DentonsUK',
  '89.0029': 'IPfolio2GP',
  '89.0025': 'FIP CGC PP',
  '89.0030': 'IPfolioQA',
  '82.047': 'HPE',
  '89.0028': 'FIP STO PP',
  '89.0016': 'IPfolIHUB',
};

export const getCustomerDisplayName = (
  customerNumber: string | number,
  customerName: string | null = null
): string => {
  const mappedName = CUSTOMER_NAMES[String(customerNumber)];
  const finalName = mappedName || customerName || 'Unknown';
  return `${customerNumber} - ${finalName}`;
};

export const getCustomerName = (customerNumber: string | number): string => {
  return CUSTOMER_NAMES[String(customerNumber)] || 'Unknown';
};
